<script setup lang="ts">
import { watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useSessionStore } from '@/stores/session-store';
import {
  closeSimulationNotice,
  isSimulationAllowedRoute,
  isSimulationSession,
  notifySimulationUnsupported,
  simulationNoticeOpen,
} from '@/shared/simulation/simulation-session';

const route = useRoute();
const router = useRouter();
const session = useSessionStore();

watch(
  () => [route.path, session.player?.accountKind, session.token] as const,
  () => {
    if (!session.token) return;
    if (!isSimulationSession(session.player?.accountKind)) return;
    if (isSimulationAllowedRoute(route.path)) return;
    notifySimulationUnsupported();
    void router.replace('/');
  },
);
</script>

<template>
  <div v-if="simulationNoticeOpen" class="sim-notice" role="presentation">
    <button class="sim-notice__backdrop" type="button" aria-label="关闭" @click="closeSimulationNotice" />
    <div class="sim-notice__panel" role="dialog" aria-modal="true" aria-labelledby="sim-notice-title">
      <p id="sim-notice-title" class="sim-notice__text">模拟账号不支持此功能</p>
      <button class="sim-notice__ok" type="button" @click="closeSimulationNotice">确定</button>
    </div>
  </div>
</template>

<style scoped>
.sim-notice {
  position: fixed;
  inset: 0;
  z-index: 5000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem;
  font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', sans-serif;
}

.sim-notice__backdrop {
  position: absolute;
  inset: 0;
  background: rgb(0 0 0 / 56%);
  border: 0;
}

.sim-notice__panel {
  position: relative;
  z-index: 1;
  box-sizing: border-box;
  width: min(16.4rem, 100%);
  padding: 1.35rem 1.1rem 1.05rem;
  color: #fff;
  background: #232325;
  border-radius: 0.7rem;
}

.sim-notice__text {
  margin: 0;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1.45;
  text-align: center;
}

.sim-notice__ok {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 2.35rem;
  margin-top: 1.15rem;
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  background: #f32240;
  border: 0;
  border-radius: 1.2rem;
}
</style>
